import { call, put, takeEvery } from 'redux-saga/effects'
import * as productPricingActions from '../ducks/productPricingDucks'
import * as productPricingApi from '../../api/productPricingApi'

interface FetchProductPricingListSaga {
  type: string
  payload: string
}

interface FetchProductPricingDetailSaga {
  type: string
  payload: string
}
interface FetchRequestListSaga {
  type: string
  payload: string
}

function* fetchListProductPricing({ payload: queryString }: FetchProductPricingListSaga) {
  try {
    const res: ReturnType<typeof productPricingApi.getListProductPricing> = yield call(productPricingApi.getListProductPricing, queryString)
    yield put(productPricingActions.getListProductPricingSuccess(res))
  } catch (error) {
    yield put(productPricingActions.getListProductPricingFail(error))
  }
}

function* fetchDetailProductPricing({ payload: id }: FetchProductPricingDetailSaga) {
  try {
    const res: ReturnType<typeof productPricingApi.getDetailProductPricing> = yield call(productPricingApi.getDetailProductPricing, id)
    yield put(productPricingActions.getDetailProductPricingSuccess(res))
  } catch (error) {
    yield put(productPricingActions.getDetailProductPricingFail(error))
  }
}

function* fetchListSearchRQ({ payload: queryString }: FetchRequestListSaga) {
  try {
    const res: ReturnType<typeof productPricingApi.getListSearchRQ> = yield call(productPricingApi.getListSearchRQ, queryString)
    yield put(productPricingActions.getListSearchRQSuccess(res))
  } catch (error) {
    yield put(productPricingActions.getListSearchRQFail(error))
  }
}


export default function* watchOrder() {
  yield takeEvery(productPricingActions.getListProductPricing.toString(), fetchListProductPricing)
  yield takeEvery(productPricingActions.getDetailProductPricing.toString(), fetchDetailProductPricing)
  yield takeEvery(productPricingActions.getListSearchRQ.toString(), fetchListSearchRQ)
}
